const overrideSpellcheck = () => {
    if (!XMLHttpRequest.nativeOpen) {
        XMLHttpRequest.prototype.nativeOpen = XMLHttpRequest.prototype.open

        XMLHttpRequest.prototype.customOpen = function (method, url, async, user, password) {
            // console.log('customOpen', method, url, async, user, password)
            // Log the request details
            // Check if the request is to the TinyMCE spelling service
            if (url.includes('https://spelling.iad.tiny.cloud/2/suggestions')) {
                // Add event listener to modify the request body before sending
                this.addEventListener('readystatechange', function () {
                    if (this.readyState === 1) {
                        // OPENED state
                        const originalSend = this.send
                        this.send = function (body) {
                            if (body) {
                                try {
                                    const parsedBody = JSON.parse(body)
                                    parsedBody.language = 'en_US-medical'
                                    const modifiedBody = JSON.stringify(parsedBody)
                                    console.log('Modified spelling request body: language set to en_US-medical')
                                    return originalSend.call(this, modifiedBody)
                                } catch (e) {
                                    console.error('Error modifying spelling request:', e)
                                    return originalSend.call(this, body)
                                }
                            }
                            return originalSend.call(this, body)
                        }
                    }
                })
                return this.nativeOpen(method, url, async, user, password)
            }
            if (url.includes('cdn.tiny.cloud/1')) {
                console.log(`Intercepted request: Method = ${method}, URL = ${url}`)

                // Check if we have a recent cache
                const cacheKey = 'tiny_cdn_lastcheck'
                const lastCheck = localStorage.getItem(cacheKey)
                const oneHourAgo = Date.now() - 60 * 60 * 1000

                if (lastCheck && parseInt(lastCheck) > oneHourAgo) {
                    console.log('Using cached response for:', url)
                    // First call the native open to properly initialize the XHR
                    this.nativeOpen(method, url, async, user, password)

                    // Override the send method for this request
                    const originalSend = this.send
                    this.send = function (data) {
                        // Mock the XHR response
                        setTimeout(() => {
                            Object.defineProperty(this, 'readyState', { value: 4 })
                            Object.defineProperty(this, 'status', { value: 200 })
                            const response = JSON.stringify({ success: true })
                            Object.defineProperty(this, 'response', { value: response })
                            Object.defineProperty(this, 'responseText', { value: response })
                            this.dispatchEvent(new Event('readystatechange'))
                            this.dispatchEvent(new Event('load'))
                        }, 0)
                        return undefined
                    }
                    return
                } else {
                    // Update the last check time
                    localStorage.setItem(cacheKey, Date.now().toString())
                    console.log('Making actual request to:', url)
                    return this.nativeOpen(method, url, async, user, password)
                }
            }

            // If no conditions match, use the original open method
            return this.nativeOpen(method, url, async, user, password)
        }
        XMLHttpRequest.prototype.open = XMLHttpRequest.prototype.customOpen
    }

    // Override fetch
    if (!window.originalFetch) {
        window.originalFetch = window.fetch
        window.fetch = async function (url, options) {
            const urlString = url.toString()
            // console.log('Fetch intercepted:', urlString, options)

            if (urlString.includes('cdn.tiny.cloud')) {
                console.log('Intercepted CDN fetch request:', urlString)

                // Check if we have a recent cache
                const cacheKey = 'tiny_cdn_lastcheck'
                const lastCheck = localStorage.getItem(cacheKey)
                const oneHourAgo = Date.now() - 60 * 60 * 1000
                if (lastCheck && parseInt(lastCheck) > oneHourAgo) {
                    console.log('Using cached response for:', urlString)
                    return new Response(JSON.stringify({ success: true }), {
                        status: 200,
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    })
                } else {
                    localStorage.setItem(cacheKey, Date.now().toString())
                    console.log('Making actual request to:', urlString)
                    return window.originalFetch(url, options)
                }
            }

            return window.originalFetch(url, options)
        }
    }
}

export default overrideSpellcheck
